/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Project_Frame_RateInputs */

const en_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Frame Rate`)
};

const fr_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequence d'images du projet`)
};

const de_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildrate des Projekts`)
};

const it_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi del progetto`)
};

const ru_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота кадров проекта`)
};

const es_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas del proyecto`)
};

const zh_cn2_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目帧速率`)
};

const ja_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのフレームレート`)
};

const hi_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ्रेम दर`)
};

const pt_pt2_editor_project_frame_rate = /** @type {(inputs: Editor_Project_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros do projeto`)
};

/**
* | output |
* | --- |
* | "Project Frame Rate" |
*
* @param {Editor_Project_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_project_frame_rate = /** @type {((inputs?: Editor_Project_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Project_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_project_frame_rate(inputs)
	if (locale === "de") return de_editor_project_frame_rate(inputs)
	if (locale === "it") return it_editor_project_frame_rate(inputs)
	if (locale === "ru") return ru_editor_project_frame_rate(inputs)
	if (locale === "es") return es_editor_project_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_project_frame_rate(inputs)
	if (locale === "ja") return ja_editor_project_frame_rate(inputs)
	if (locale === "hi") return hi_editor_project_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_project_frame_rate(inputs)
	return en_editor_project_frame_rate(inputs)
});